import { render, staticRenderFns } from "./courseAdministrator.vue?vue&type=template&id=37933694&scoped=true"
import script from "./courseAdministrator.vue?vue&type=script&lang=js"
export * from "./courseAdministrator.vue?vue&type=script&lang=js"
import style0 from "./courseAdministrator.vue?vue&type=style&index=0&id=37933694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37933694",
  null
  
)

export default component.exports